import { config } from '~app/config';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { makeRequest } from '@breezeventures/web-lib-ph-request/make-request';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { companyCategoryKeys } from './company-category-keys';

import type { FindAllCategoriesResponse } from '../model';

export const useCategories = (
  options?: UseQueryOptions<FindAllCategoriesResponse>
) => {
  return useQuery({
    queryKey: companyCategoryKeys.list(),
    queryFn: () => {
      return makeRequest<ResponseSuccess<FindAllCategoriesResponse>>({
        url: `${config.apiHost}/companies/api/v1/web/category/find-all`,
        credentials: 'include',
        payload: {},
      }).then((response) => response.payload);
    },
    ...options,
  });
};
